module.exports = __webpack_public_path__ + "static/media/app.70cea92a.jpeg";